// platforms: gösterilecek mağaza düğmeleri. URL boşsa düğme "Soon" olarak gösterilir.
const apps = [
  {
    name: "Motoway",
    category: "Navigation · Community",
    description:
      "Maps, routes and a riding community built for motorcyclists. Plan the road, share the ride, and know what's ahead before you get there.",
    image: "/images/Motoway.png",
    imageKind: "icon",
    platforms: ["appStore", "playStore"],
    appStoreUrl: "https://apps.apple.com/tr/app/motoway-motosiklet-rota/id6821430508",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.meckinteractive.motoway",
  },
  {
    name: "Bitig",
    category: "Productivity · Security",
    description:
      "Passwords, 2FA codes, notes, tasks and projects in one end-to-end encrypted vault. Syncs through your own cloud on Windows, Mac, iPhone and Android.",
    image: "/images/Bitig.png",
    imageKind: "icon",
    platforms: ["download", "web"],
    downloadUrl: "https://bitig.meck-int.com/indir/",
    webUrl: "https://bitig.meck-int.com/app/",
  },
  {
    name: "Heartvale Town",
    category: "Simulation · Game",
    description:
      "A calm medieval village builder in your browser. Draw walls, houses, castles, fields and roads, then watch your villagers live their own lives. Free, no download.",
    image: "/images/Heartvale.png",
    imageKind: "icon",
    platforms: ["web"],
    webUrl: "https://playheartvale.meck-int.com",
  },
  {
    name: "Ember & Chain",
    category: "Roguelike · Card Game",
    description:
      "A one-handed pixel dungeon and deck game. Pick a hero, dive a hundred floors, and chain cards of the same rune to multiply every hit.",
    image: "/images/EmberChain.png",
    imageKind: "icon",
    platforms: ["web", "android"],
    webUrl: "https://emberandchain.meck-int.com/play/",
    androidUrl: "https://emberandchain.meck-int.com/#android",
  },
  {
    name: "PinBasket",
    category: "Arcade · Game",
    description:
      "Classic pinball physics meets basketball scoring. Flip, bounce off bumpers and ramps, and land trick shots into the hoop.",
    image: "/images/PinBasket.png",
    imageKind: "screen",
    platforms: [],
  },
];

export default apps;
